<template>
  <div class="container">
    <div class="title">{{ $t('m.notfind.title') }}</div>
    <div class="txt">
      {{ $t('m.notfind.txt') }}
    </div>

    <img src="../assets/images/404_img.png" alt="" srcset="" />
    <Btn :text="$t('m.notfind.btn')" :route="'/'"></Btn>
  </div>
</template>
<script>

import Btn from "../components/Btn.vue";
export default {
  components: { Btn }
};
</script>
<style lang="scss" scoped>
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-wrap: nowrap;
  flex-grow: 1;
  padding: 40px 0 0px;
  // background-image: url("../assets/images/404_bg.png");


  .title {
    font-family: MohrRounded Heavy, 'FZLanTYK_Black', Microsoft YaHei, sans-serif;
    font-size: 75px;
    margin-top: 30px;
    color: #9b907e;
  }

  .txt {
    color: #5073c3;
    margin: -32px 10% 50px;
    text-align: center;
    font-size: 20px;
    line-height: 1.6;
    color: #5c5956;
    font-family: 'MohrRounded Black', 'FZLanTYK_Black', Microsoft YaHei, sans-serif;
  }

  img {
    margin-bottom: 48px;
    background-size: 100% 100%;
    max-width: 90%;
  }

  .btn {
    // margin-top: 40px;
    padding: 9px 40px 13px;
    background-color: #ffd240;
    // margin-top: 90px;
    color: #603a1f;
    font-family: 'MohrRounded Black', 'FZLanTYK_Black', Microsoft YaHei, sans-serif;
    border-radius: 18px;
    font-size: 18px;
    margin-top: 20px;
  }

  #btn {
    min-width: 50px;
    font-size: 18px;
    padding: 11px 30px 13px;
  }
}

@media screen and (max-width:700px) {
  .txt {
    // font-size: 4vw !important;
    text-align: center;
  }

  .title {
    font-family: MohrRounded Heavy, 'FZLanTYK_Black', Microsoft YaHei, sans-serif;
    // font-size: 14vw  !important;
    margin-top: 30px;
    color: #9b907e;
  }
}

@media screen and (max-width:500px) {
  .txt {
    font-size: 18px !important;
    text-align: center;
    margin: 0 10px;
  }

  .title {
    font-family: MohrRounded Heavy, 'FZLanTYK_Black', Microsoft YaHei, sans-serif;
    font-size: 14vw !important;

    margin-top: 30px;
    color: #9b907e;
  }
}
</style>